var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubrayado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97713 0.660156H1.59338V7.86466C1.59338 10.2328 3.24712 11.9405 6 11.9405C8.75287 11.9405 10.4066 10.2328 10.4066 7.86466V0.660156H9.02287V7.77353C9.02287 9.44978 7.92263 10.6648 6 10.6648C4.07737 10.6648 2.97713 9.44978 2.97713 7.77353V0.660156ZM11.0625 14.0072H0.9375V12.8822H11.0625V14.0072Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubrayado);
export default __webpack_public_path__ + "static/media/Subrayado.eb9acf0236562a5d1bc7d32f85887235.svg";
export { ForwardRef as ReactComponent };